"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTooltipContainer = exports.PrefixGlobalStyle = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _Tooltip = _interopRequireDefault(require("../ykb-styled-components/Globals/components/Tooltip"));
var _excluded = ["children", "className", "prefixCls", "error"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var PrefixGlobalStyle = exports.PrefixGlobalStyle = (0, _ykbStyledComponents.createGlobalStyle)(["", ""], function (props) {
  return (0, _Tooltip.default)(props);
});
var StyledContainer = function StyledContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    error = _ref.error,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefix = prefixCls ? prefixCls : 'ykb-ui-tooltip';
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children(prefix), prefixCls && /*#__PURE__*/_react.default.createElement(PrefixGlobalStyle, (0, _extends2.default)({
    prefixCls: prefix,
    $error: error
  }, rest)));
};
var StyledTooltipContainer = exports.StyledTooltipContainer = (0, _ykbStyledComponents.default)(StyledContainer).withConfig({
  componentId: "ykb-ui__sc-rm5j5c-0"
})([""]);